import { YoutubeList } from '../components/youtube/YoutubeList'

export const Youtube = () => {
    return(
        <>
        <YoutubeList />
        </>
    )
}